(function () {
  'use strict';

  angular
    .module('crewVoyageReport')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('crewVoyageReport', {
        sticky: true,
        url: '/crew-voyage-report',
        views: {
          'crewVoyageReportView': {
            templateUrl: 'crew-voyage-report/views/crew-voyage-report.tpl.html',
            controller: 'CrewVoyageReportCtrl',
            controllerAs: 'crewVoyageReport'
          }
        }

      });
  }
}());
